import { render, staticRenderFns } from "./ItemGroupForm.vue?vue&type=template&id=73b21238&scoped=true&"
import script from "./ItemGroupForm.vue?vue&type=script&lang=js&"
export * from "./ItemGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b21238",
  null
  
)

export default component.exports